"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ContactDetailsForm_1 = require("./ContactDetailsForm");
exports.ContactDetailsForm = ContactDetailsForm_1.default;
var CommentsForm_1 = require("./CommentsForm");
exports.CommentsForm = CommentsForm_1.default;
var DisabilitiesForm_1 = require("./DisabilitiesForm");
exports.DisabilitiesForm = DisabilitiesForm_1.default;
var EthnicityDetailsForm_1 = require("./EthnicityDetailsForm");
exports.EthnicityDetailsForm = EthnicityDetailsForm_1.default;
var MedicalDetailsForm_1 = require("./MedicalDetailsForm");
exports.MedicalDetailsForm = MedicalDetailsForm_1.default;
var PersonalDetailsForm_1 = require("./PersonalDetailsForm");
exports.PersonalDetailsForm = PersonalDetailsForm_1.default;
var RestrictionsDetailsForm_1 = require("./RestrictionsDetailsForm");
exports.RestrictionsDetailsForm = RestrictionsDetailsForm_1.default;
var CarersDetailsForm_1 = require("./CarersDetailsForm");
exports.CarersDetailsForm = CarersDetailsForm_1.default;
//# sourceMappingURL=index.js.map